<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>{{$t('home.customerPolicy.header')}}</h4>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="table" @onRowSelected="onRowSelected" vuexModule="Homepage" searchAction="getCustomerPolicyList" type="renewal" :columns="columns" :filters="filters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITSearchableTable } from '@/components'

import { mapGetters } from 'vuex';
export default {
  name: 'CustomerDashboard',
  components: {
    FITSearchableTable,
    FITFormCard
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
  },
  methods: {
    onRowSelected(row) {
      this.$router.push({ name: 'Customer Policy Detail', params: { detail: row } });
    },
    getTranslated(type, key) {
      console.log(type, key);
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Homepage', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
  },
  data() {
    return {
      filters: [{
        label: this.$t('dw.general.policyType'),
        key: 'policyType',
        type: 'select',
        default: null,
        haveAll: true,
      }],
      columns: [{
          key: 'policyNumber',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyNumber'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row);
          }
        },
        {
          key: 'productEnglishName',
          label: this.$t('osm.product.productName'),
          sortable: true,
          formatter: (row, key, item) => {
            return item.productEnglishName + "</br>" + item.productChineseName;
          }
        }, {
          key: 'policyType',
          label: this.$t('osm.renewal.list.policyType'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated('policyType', row);
          }
        },
        {
          key: 'modalPremium',
          label: this.$t('osm.renewal.list.modalPremium'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'nextPaymentDate',
          label: this.$t('home.customerPolicy.nextPaymentDate'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.date(row);
          }
        },
        {
          key: 'englishNameServiceAgent',
          label: this.$t('home.customerPolicy.agentName'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(item.englishNameServiceAgent) + "</br>" + this.$options.filters.isEmpty(item.chineseNameServiceAgent);
          }
        }
      ]
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/containers/CustomerDashboard.vue